import { Mesh, MeshBasicMaterial, Object3D, PlaneGeometry, Vector2, Vector3, Box3 } from 'three';
import WelcomeScreen from '../components/WelcomeScreen';
import ErrorModal from '../components/ErrorModal';
import { ActionControllerEventName, ButtonComponent, Level, ResourcesManager, ResourceType, ScenarioProcessor, Viewer } from '@verybigthings/vbt-webvr-framework';
import { config, zSpaceConfig } from '../config';
import * as styleConfig from '../styleConfig';
import Modal from '../components/Modal';
import MainMenuComponent from '../components/MainMenuComponent';
import { deepClone } from '@verybigthings/vbt-webvr-framework/build/main/ts/utils/DeepClone';
import IconButtonComponent from '@verybigthings/vbt-webvr-framework/build/main/ts/components/IconButtonComponent';
import { MaterialImprovement } from '../utils/MaterialImprovement';
import { PickingControllerEvents } from '@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController';
import { PreparationPickingObjects } from '../utils/PreparationPickingObjects';
export default class PPELevel extends Level {
    constructor(app) {
        super(config);
        this.numbItemsWorn = -1;
        window['ppe'] = this;
        this.app = app;
        this.resourcesInUse = [
            {
                name: 'lobby_table',
                url: require('../../assets/models/lobby_table.fbx'),
                priority: 0,
                type: ResourceType.FBX_MODEL
            },
            // SOUNDS
            {
                name: 'plastic_1_sound',
                url: require('../../assets/sounds/plastic_1_sound.mp3'),
                type: ResourceType.AUDIO,
                priority: 0,
            },
            {
                name: 'plastic_2_sound',
                url: require('../../assets/sounds/plastic_2_sound.mp3'),
                type: ResourceType.AUDIO,
                priority: 0,
            },
            {
                name: 'latex_gloves_sound',
                url: require('../../assets/sounds/latex_gloves_sound.mp3'),
                type: ResourceType.AUDIO,
                priority: 0,
            },
        ];
        this.zSpacePositions = zSpaceConfig.ppe;
        this.cameraPosition = new Vector3(0, -8, 30);
        this.cameraTargetNormal = new Vector3(0, -8, 29.95);
        this.ppeContainer = new Object3D();
        this.ppeContainer.position.set(0, 0, 55);
        this.ppeContainer.rotation.set(0, Math.PI, 0);
        this.addObject(this.ppeContainer, {
            geometry: true,
            material: true,
            maps: true,
            actions: true,
            viewer: true,
        });
        this.clothesList = ['stack_of_clothes', 'mask', 'goggles', 'left_glove', 'right_glove'];
        console.log('PPE CONSTRUCTOR');
        this.initZSpaceSettings();
    }
    initZSpaceSettings() {
        Viewer.on('goToZSpace', () => {
            console.log('goToZSpace--------');
            if (!this.uiObject.parent)
                return;
            // const viewerScaleCoef = (this.app.determineZSpaceDevice.viewerScaleCoef) ? this.app.determineZSpaceDevice.viewerScaleCoef : 1;
            Viewer.controls.saveState();
            const ppeZSpaceZeroParallax = new Vector3(this.zSpacePositions.zSpacePosition.x, -10.4, 14.5);
            setTimeout(() => {
                var _a, _b, _c, _d;
                // @ts-ignore
                Viewer.controls.zController.setPosition(this.zSpacePositions.zSpacePosition.clone());
                // @ts-ignore
                Viewer.controls.zController.setViewerScale(this.zSpacePositions.viewerScale * this.app.determineZSpaceDevice.viewerScaleCoef);
                // @ts-ignore
                Viewer.controls.zController.setYaw(this.zSpacePositions.yaw);
                // @ts-ignore
                Viewer.controls.zController.setPitch(this.zSpacePositions.pitch);
                this.welcomeScreen.uiObject.position.copy(ppeZSpaceZeroParallax);
                this.welcomeScreen.uiObject.quaternion.copy(Viewer.controls.zController.quaternion);
                this.welcomeScreen.uiObject.scale.setScalar(0.6);
                (_a = this.msgModal) === null || _a === void 0 ? void 0 : _a.uiObject.position.copy(ppeZSpaceZeroParallax);
                (_b = this.msgModal) === null || _b === void 0 ? void 0 : _b.uiObject.quaternion.copy(Viewer.controls.zController.quaternion);
                (_c = this.msgModal) === null || _c === void 0 ? void 0 : _c.uiObject.scale.setScalar(0.6);
                if (this.numbItemsWorn < 5) {
                    (_d = this.msgModal) === null || _d === void 0 ? void 0 : _d.init('Task:', `Drag the PPE items on the table to apply \n them to dress the mannequin in the \n following order: \n 1. Gown \n 2. Face mask \n 3. Goggles \n 4. Gloves. \n This is important for safety!`);
                }
                this.errorModal.uiObject.position.copy(ppeZSpaceZeroParallax);
                this.errorModal.uiObject.quaternion.copy(Viewer.controls.zController.quaternion);
                this.errorModal.uiObject.scale.setScalar(0.6);
                this.logo.position.set(this.zSpacePositions.zSpacePosition.x, -8.35, 13.8);
                this.logo.quaternion.copy(Viewer.controls.zController.quaternion);
                this.logo.scale.setScalar(0.1);
                this.muteBtn.uiObject.position.set(-1.85, -8.45, 13.8);
                this.muteBtn.uiObject.quaternion.copy(Viewer.controls.zController.quaternion);
                this.muteBtn.uiObject.scale.setScalar(0.12);
            }, 150);
        });
        Viewer.on('goFromZSpace', () => {
            if (!this.uiObject.parent)
                return;
            console.log('goFromZSpace::::::::');
            setTimeout(() => {
                var _a, _b, _c, _d, _e;
                Viewer.controls.reset();
                this.welcomeScreen.uiObject.position.copy(this.welcomeScreen.uiObject.userData.pcPosition);
                this.welcomeScreen.uiObject.rotation.set(0, 0, 0);
                this.welcomeScreen.uiObject.scale.setScalar(1);
                (_a = this.msgModal) === null || _a === void 0 ? void 0 : _a.uiObject.position.copy((_b = this.msgModal) === null || _b === void 0 ? void 0 : _b.uiObject.userData.pcPosition);
                (_c = this.msgModal) === null || _c === void 0 ? void 0 : _c.uiObject.rotation.set(0, 0, 0);
                (_d = this.msgModal) === null || _d === void 0 ? void 0 : _d.uiObject.scale.setScalar(1);
                if (this.numbItemsWorn < 5) {
                    (_e = this.msgModal) === null || _e === void 0 ? void 0 : _e.init('Task:', `Click the PPE items on the table to apply \n them in the following order: \n 1. Gown \n 2. Face mask \n 3. Goggles \n 4. Gloves. \n This is important for safety!`);
                }
                this.errorModal.uiObject.position.copy(this.errorModal.uiObject.userData.pcPosition);
                this.errorModal.uiObject.rotation.copy(this.errorModal.uiObject.userData.pcRotation);
                this.errorModal.uiObject.scale.setScalar(1);
                this.logo.position.copy(this.logo.userData.pcPosition);
                this.logo.rotation.set(0, 0, 0);
                this.logo.scale.setScalar(1);
                this.muteBtn.uiObject.position.copy(this.muteBtn.uiObject.userData.pcPosition);
                this.muteBtn.uiObject.rotation.set(0, 0, 0);
                this.muteBtn.uiObject.scale.setScalar(1);
            }, 150);
        });
    }
    init(event) {
        super.init(event);
        if (Viewer.zSpace)
            Viewer.zSpace.onChangeValidator = () => true;
        this.logo = new Mesh(new PlaneGeometry(5.4 * 5, 1.2 * 5), new MeshBasicMaterial({
            map: ResourcesManager.getTexture('logo_image'),
            transparent: true
        }));
        this.addObject(this.logo);
        this.logo.position.set(0, 20, -45);
        this.logo.userData.pcPosition = this.logo.position.clone();
        this.muteBtn = new IconButtonComponent({
            diameter: 3.8,
            iconSize: 0.85,
            text: '',
            background: styleConfig.MAIN_BACKGROUND_COLOR.getStyle(),
        });
        this.muteBtn.uiObject.name = 'MuteBtn';
        this.muteBtn.uiObject.position.set(-18, 19, -45);
        this.muteBtn.uiObject.userData.pcPosition = this.muteBtn.uiObject.position.clone();
        this.addObject(this.muteBtn.uiObject);
        this.muteBtn.on(ActionControllerEventName.click, () => this.toggleSound());
        this.wrapScreenUI = new Object3D();
        this.wrapScreenUI.name = 'WrapScreenUI';
        this.wrapScreenUI.position.set(0, 9.48, 0);
        this.wrapScreenUI.scale.multiplyScalar(2.7);
        this.addObject(this.welcomeScreen = new WelcomeScreen());
        this.welcomeScreen.uiObject.position.set(0, -7, 16);
        this.welcomeScreen.uiObject.userData.pcPosition = this.welcomeScreen.uiObject.position.clone();
        this.initMenu();
        this.initScenario();
        this.initErrorModal();
    }
    initScenario() {
        this.scenario = {
            name: 'lobby',
            modules: [
                { name: 'welcomeScreen', instance: this.welcomeScreen }
            ],
            steps: [{
                    onBefore: [
                        ['welcomeScreen', 'init',
                            'Welcome to Biotech VR!',
                            `Biotech VR is a virtual lab that lets you practice biotechnology experiments safely without wasting materials.`,
                            'Next'
                        ],
                        () => this.initTableClothes(),
                    ],
                    stepCondition: () => new Promise((resolve => this.welcomeScreen.once('ok', () => {
                        this.welcomeScreen.uiObject.visible = true;
                        this.app.initMainTheme();
                        resolve();
                    }))),
                },
                {
                    onBefore: [
                        ['welcomeScreen', 'init',
                            'Welcome to Biotech VR!',
                            'Before you begin to complete the tasks you need to get dressed. A table with clothes is in front of you.',
                            'Start'
                        ]
                    ],
                    stepCondition: () => new Promise((resolve => this.welcomeScreen.once('ok', () => {
                        this.welcomeScreen.uiObject.visible = false;
                        this.initModal();
                        this.initSelfModel();
                        this.initClothesEvents();
                        resolve();
                    }))),
                }, {}]
        };
        const scenarioProcessor = new ScenarioProcessor(this.scenario);
        scenarioProcessor.init();
    }
    initSelfModel() {
        this.mySelf = ResourcesManager.getModel('female');
        this.mySelf.name = 'female';
        this.mySelf.position.set(3.2, 0, 0.15);
        this.mySelf.rotateY(Math.PI);
        this.mySelf.scale.multiplyScalar(0.17);
        this.msgModal.addObject(this.mySelf);
        this.mySelf.traverse(el => {
            if (el.isMesh && el.name !== 'female') {
                const clothesPH = deepClone(el);
                clothesPH.name += '_PH';
                clothesPH.material = new MeshBasicMaterial({ color: 0x00ff00, transparent: true, opacity: 0 });
                el.userData.ph = clothesPH;
                this.mySelf.add(clothesPH);
                el.visible = false;
            }
        });
        const leftGlovePH = this.mySelf.getObjectByName('left_glove_on_PH');
        const rightGlovePH = this.mySelf.getObjectByName('right_glove_on_PH');
        leftGlovePH.material = rightGlovePH.material;
        this.goToNextClothes(this.clothesList[0]);
    }
    goToNextClothes(clothesName) {
        if (this.currTweenClothes) {
            this.currTweenClothes.stop();
            const prevClothes = this.mySelf.getObjectByName(clothesName + '_on_PH');
            if (prevClothes.parent)
                prevClothes.parent.remove(prevClothes);
        }
        this.numbItemsWorn++;
        if (this.numbItemsWorn < 4) {
            const nextClothes = this.mySelf.getObjectByName(this.clothesList[this.numbItemsWorn] + '_on_PH');
            this.animProperty(nextClothes.material, 'opacity', 1, 0);
        }
        else if (this.numbItemsWorn === 4) {
            const nextGlovePHName = (clothesName === 'left_glove') ? 'right_glove_on_PH' : 'left_glove_on_PH';
            const nextGlovePH = this.mySelf.getObjectByName(nextGlovePHName);
            this.animProperty(nextGlovePH.material, 'opacity', 1, 0);
        }
        else {
            this.updateToGreatModal();
        }
    }
    initModal() {
        this.msgModal = new Modal();
        this.addObject(this.msgModal.uiObject);
        if (Viewer.controls.zController) {
            this.msgModal.uiObject.position.set(this.zSpacePositions.zSpacePosition.x, -10.44, 14.5);
            this.msgModal.uiObject.quaternion.copy(Viewer.controls.zController.quaternion);
            this.msgModal.uiObject.scale.setScalar(0.65);
        }
        else {
            this.msgModal.uiObject.position.set(0, -8.5, 15);
        }
        this.msgModal.uiObject.userData.pcPosition = new Vector3(0, -8.5, 15);
        this.msgModal.init('Task:', (Viewer.controls.zController)
            ? `Drag the PPE items on the table to apply \n them to dress the mannequin in the \n following order: \n 1. Gown \n 2. Face mask \n 3. Goggles \n 4. Gloves. \n This is important for safety!`
            : `Click the PPE items on the table to apply \n them in the following order: \n 1. Gown \n 2. Face mask \n 3. Goggles \n 4. Gloves. \n This is important for safety!`);
        const textOptions = this.msgModal.text.options;
        textOptions.text.align = 'left';
        this.msgModal.text.updateElement(textOptions);
        this.msgModal.text.uiObject.position.x = -0.46;
    }
    updateToGreatModal() {
        this.mySelf.parent.remove(this.mySelf);
        this.msgModal.init('Great!', 'Now you can begin performing experiments.', 'START');
        const textOptions = this.msgModal.text.options;
        textOptions.text.align = 'center';
        this.msgModal.text.updateElement(textOptions);
        this.msgModal.header.uiObject.position.y = 0.67;
        this.msgModal.uiObject.children[0].position.y = -0.48;
        this.msgModal.uiObject.children[0].scale.set(0.74, 0.76, 1);
        this.msgModal.text.uiObject.position.x = 0;
        this.msgModal.text.uiObject.position.y = -0.5;
        this.msgModal.once('ok', () => this.fire('level_done'));
    }
    initErrorModal() {
        this.errorModal = new ErrorModal();
        this.errorModal.uiObject.position.set(0, -8.34, 14);
        this.errorModal.uiObject.userData.pcPosition = this.errorModal.uiObject.position.clone();
        this.errorModal.uiObject.userData.pcRotation = this.errorModal.uiObject.rotation.clone();
        this.addObject(this.errorModal.uiObject);
        this.errorModal.init('Error', 'Wrong order. Try again.');
        this.errorModal.on('ok', () => {
            this.errorModal.uiObject.visible = false;
            this.msgModal.uiObject.visible = true;
        });
        this.errorModal.uiObject.visible = false;
    }
    initTableClothes() {
        this.lobbyTable = ResourcesManager.getModel('lobby_table');
        this.lobbyTable.traverse(el => {
            if (el.name.includes('pPlane'))
                el.parent.remove(el);
        });
        MaterialImprovement.upgradeMaterialsFromModel(this.lobbyTable, 'ppe_level');
        this.lobbyTable.name = 'lobby_table';
        this.lobbyTable.position.set(0, -19, 43);
        this.lobbyTable.getObjectByName('table1').scale.set(1, 1.2, 1);
        this.lobbyTable.getObjectByName('goggles').position.y = 0.02;
        const left_glove = this.lobbyTable.getObjectByName('left_glove');
        left_glove.material = left_glove.material.clone();
        this.ppeContainer.add(this.lobbyTable);
    }
    initClothesEvents() {
        const checkDressClothes = (clothesObject) => {
            const currPickObject_on = this.mySelf.getObjectByName(clothesObject.name + '_on');
            if (clothesObject.name === 'stack_of_clothes') {
                if (Viewer.controls.zController)
                    clothesObject.visible = false;
                currPickObject_on.visible = true;
                ResourcesManager.getAudioManger().getAudio('plastic_1_sound').play();
                this.goToNextClothes(clothesObject.name);
                this.flyClothes(clothesObject);
            }
            if (clothesObject.name === 'mask') {
                if (this.numbItemsWorn === 1) {
                    if (Viewer.controls.zController)
                        clothesObject.visible = false;
                    currPickObject_on.visible = true;
                    ResourcesManager.getAudioManger().getAudio('plastic_2_sound').play();
                    this.goToNextClothes(clothesObject.name);
                    this.flyClothes(clothesObject);
                }
                else {
                    this.msgModal.uiObject.visible = false;
                    this.errorModal.uiObject.visible = true;
                }
            }
            if (clothesObject.name === 'goggles') {
                if (this.numbItemsWorn === 2) {
                    if (Viewer.controls.zController)
                        clothesObject.visible = false;
                    currPickObject_on.visible = true;
                    this.goToNextClothes(clothesObject.name);
                    this.flyClothes(clothesObject);
                }
                else {
                    this.msgModal.uiObject.visible = false;
                    this.errorModal.uiObject.visible = true;
                }
            }
            if (clothesObject.name.includes('_glove')) {
                if (this.numbItemsWorn >= 3) {
                    if (Viewer.controls.zController)
                        clothesObject.visible = false;
                    currPickObject_on.visible = true;
                    ResourcesManager.getAudioManger().getAudio('latex_gloves_sound').play();
                    this.goToNextClothes(clothesObject.name);
                    this.flyClothes(clothesObject);
                }
                else {
                    this.msgModal.uiObject.visible = false;
                    this.errorModal.uiObject.visible = true;
                }
            }
        };
        this.actionController.on(ActionControllerEventName.click, this.lobbyTable, (event) => {
            if (Viewer.controls.zController)
                return;
            if (this.errorModal.uiObject.visible)
                return;
            const currFemaleMesh = this.mySelf.getObjectByName(event.intersectedObject.name + '_on');
            if (!currFemaleMesh)
                return;
            checkDressClothes(event.intersectedObject);
        });
        if (Viewer.zSpace) {
            this.clothesList.forEach(clothesName => {
                const currPickObject = this.lobbyTable.getObjectByName(clothesName);
                PreparationPickingObjects.saveObjectState(currPickObject);
                this.app.zSpacePickingController.on(PickingControllerEvents.PICKED, currPickObject, () => {
                    Viewer.scene.add(currPickObject);
                    currPickObject.traverse(el => {
                        el.userData.oldRaycast = el.raycast;
                        el.raycast = () => { };
                    });
                    this.app.zSpacePickingController.once(PickingControllerEvents.RELEASED, currPickObject, () => {
                        const currPickObjectCenter = new Box3().setFromObject(currPickObject).getCenter(new Vector3());
                        const distanceToMySelf = currPickObjectCenter.distanceTo(this.mySelf.getWorldPosition(new Vector3()));
                        if (distanceToMySelf < 5)
                            checkDressClothes(currPickObject);
                        PreparationPickingObjects.flyObjectToPrevState(currPickObject);
                        this.actionController.off(ActionControllerEventName.buttonUp, this.mySelf);
                        setTimeout(() => currPickObject.traverse(el => el.raycast = el.userData.oldRaycast));
                    });
                });
            });
        }
    }
    animProperty(object, property, oldVal, newVal) {
        this.currTweenClothes = new TWEEN.Tween({ alpha: oldVal }).to({ alpha: newVal }, 700)
            .onUpdate((alpha) => {
            object[property] = (oldVal > newVal) ? alpha : newVal - alpha;
        })
            .onComplete(() => this.animProperty(object, property, newVal, oldVal))
            .start();
    }
    flyClothes(clothes, newPos) {
        const oldPosition = clothes.position.clone();
        const newPosition = clothes.worldToLocal(Viewer.controls.target.clone());
        const tweenFlyClothes = new TWEEN.Tween({ alpha: 0 }).to({ alpha: 1 }, 2000)
            .easing(TWEEN.Easing.Quadratic.Out)
            .onUpdate((alpha) => {
            const currCord = oldPosition.clone().lerp(newPosition, alpha);
            clothes.position.copy(currCord);
            const currOpacity = 1 - alpha * 3;
            if (currOpacity <= 0) {
                clothes.parent.remove(clothes);
                tweenFlyClothes.stop();
            }
            if (clothes.material.length) {
                clothes.material.forEach(material => {
                    material.transparent = true;
                    material.opacity = currOpacity;
                });
            }
            else {
                clothes.material.transparent = true;
                clothes.material.opacity = currOpacity;
            }
        })
            .onComplete(() => { })
            .start();
    }
    initMenu() {
        this.menuBtn = new ButtonComponent({
            size: new Vector3(.7, .7, 1),
            sizePx: new Vector2(64, 64),
            type: 'icon',
            text: {
                value: '',
                style: { color: 'white', family: 'FontAwesome', size: '36px' },
                margin: { top: 0, bottom: 15 }
            },
            background: { color: styleConfig.MAIN_BACKGROUND_COLOR.getStyle() }
        });
        this.menuBtn.uiObject.position.set(-3.2, 1.7, 0);
        this.menuBtn.uiObject.name = 'menuBtn';
        this.wrapScreenUI.add(this.menuBtn.uiObject);
        this.menuComponent = new MainMenuComponent({
            innerRadius: 0.6,
            outerRadius: 1.3,
            borderWidth: 0.01,
            borderColor: styleConfig.WINDOW_BORDER_COLOR.getHex(),
            bgColor: 0xffffff,
            centerText: {
                value: '',
                style: { color: 'black', size: '32px' },
                align: 'center',
                lineHeight: 60,
                margin: { bottom: 40 },
                autoWrappingHorizontal: false,
                autoWrapping: true
            },
            sectorColors: {
                default: styleConfig.MAIN_BACKGROUND_COLOR.getHex(),
                hover: styleConfig.MAIN_BACKGROUND_HOVER.getHex(),
            },
            enableCancelButton: true,
        });
        this.menuComponent.uiObject.position.set(0, -0.82, 5);
        this.menuComponent.uiObject.scale.multiplyScalar(0.6);
        this.menuComponent.uiObject.visible = false;
        this.menuComponent.uiObject.name = 'menuComponent';
        this.wrapScreenUI.add(this.menuComponent.uiObject);
        this.menuBtn.on(ActionControllerEventName.click, () => {
            if (this.app.pointerController.currentPointerObject === this.app.pointerController.defaultPointerObject ||
                this.app.pointerController.currentPointerObject === undefined ||
                this.app.pointerController.currentPointerObject === null) {
                this.showMenu(true);
            }
        });
        this.menuComponent.on('play', () => this.showMenu(false));
        this.menuComponent.on('canceled', () => this.showMenu(false));
        this.menuComponent.on('exit', () => this.showMenu(false));
        this.menuComponent.on('toggleSound', () => this.toggleSound(true));
    }
    toggleSound(isFromMenu = false) {
        if (this.app.muted)
            ResourcesManager.getAudioManger().unMuteAll();
        else
            ResourcesManager.getAudioManger().muteAll();
        this.app.muted = !this.app.muted;
        this.muteBtn.setText(this.app.muted ? '' : '');
        if (!isFromMenu)
            this.menuComponent.soundMeshButton.setText(this.app.muted ? '' : '');
    }
    showMenu(isShow = true) {
        this.menuBtn.uiObject.visible = !isShow;
        this.menuComponent.uiObject.visible = isShow;
    }
    startAnimation() {
        console.log('startAnimation');
        return super.startAnimation().then(() => { });
    }
    endAnimation() {
        console.log('endAnimation');
        if (Viewer.zSpace)
            Viewer.zSpace.onChangeValidator = () => false;
        const applyZSpacePreloader = () => {
            if (Viewer.controls.zController) {
                Viewer.scene.add(this.app.preloader.uiObject);
                this.app.preloader.uiObject.position.set(-0.05, -9.84, 22.8);
                this.app.preloader.uiObject.quaternion.copy(Viewer.controls.zController.quaternion);
            }
        };
        setTimeout(() => applyZSpacePreloader(), 100);
        return super.endAnimation().then(() => {
            console.log('endAnimation PROMISE');
        });
    }
}
